import React, { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import './csaelection.css';
import articleContext from './articlecontext';

const CsaElectionVicePres = () => {
  const [artdata, setArtdata] = useContext(articleContext);
  const location = useLocation();
  const year = location.state?.year || 2025;

  useEffect(() => {
    if (!artdata || artdata.length === 0) {
      axios.get('https://dojma-website-2pip.onrender.com/data')
        .then(res => setArtdata(res.data.slice().reverse()))
        .catch(err => console.error(err));
    }
  }, []);

  if (!artdata || artdata.length === 0) return <div className="csa-container">Loading...</div>;

  return (
    <div className='bigg'>
      <div className='thebig6'>
        <Link to={"/csaelection_pres"} state={{ year }} className='big6text'>President</Link>
        <Link to={"/csaelection_vicepres"} state={{ year }} className='big6text'>Vice President</Link>
        <Link to={"/csaelection_gensec"} state={{ year }} className='big6text'>Gen Sec</Link>
        <Link to={"/csaelection_sportssec"} state={{ year }} className='big6text'>Sports Sec</Link>
        <Link to={"/csaelection_girlsconvener"} state={{ year }} className='big6text'>Girls Convener</Link>
        <Link to={"/csaelection_treasurer"} state={{ year }} className='big6text'>Treasurer</Link>
        <Link to={"/csaelection_nota"} state={{ year }} className='big6text'>NOTA</Link>
        <Link to={"/csaelection_phdrep"} state={{ year }} className='big6text'>PhD Rep</Link>
      </div>
      <div className="csa-container">
        {artdata
          .filter((item) => item.opinion?.toLowerCase() === "csa" && item.position?.toLowerCase() === "vicepres" && item.date?.includes(year.toString()))
          .map((item, index) => (
            <div className="candidate-card" key={index}>
              {item.image && (
                <div className="candidate-image-container">
                  <img className="candidate-img" src={item.image} alt={item.name} />
                </div>
              )}
              <div className="candidate-details">
                <h2 className="candidate-name">{item.candidatename?.toUpperCase()}</h2>
                <h3 className="candidate-position">VICE PRESIDENT</h3>
                <p className="candidate-body">{item.body}</p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CsaElectionVicePres;
